// Prefer available stock when opening a bed page; preserve deliberate later choices.
if (!customElements.get('astra-bed-stock-alternatives')) customElements.define('astra-bed-stock-alternatives', class extends HTMLElement {
 connectedCallback() {
  if (this.listener) return;
  this.sizeNotice = document.querySelector(`[data-bed-size-notice="${this.dataset.productId}"]`);
  const currentUrl = new URL(window.location.href);
  const unavailableSize = currentUrl.searchParams.get('bed_unavailable_size');
  if (this.sizeNotice && ['standard', 'grande'].includes(unavailableSize)) {
   this.sizeNotice.textContent = this.sizeNotice.dataset.message.replace('{size}', unavailableSize === 'grande' ? 'Grande' : 'Standard');
   this.sizeNotice.hidden = false;
  }
  if (this.dataset.initialAvailableVariant) {
   const target = new URL(this.dataset.initialUrl, window.location.href);
   target.search = currentUrl.search;
   target.searchParams.delete('option_values');
   target.searchParams.set('variant', this.dataset.initialAvailableVariant);
   if (this.dataset.initialSize !== this.dataset.replacementSize) target.searchParams.set('bed_unavailable_size', this.dataset.initialSize);
   else target.searchParams.delete('bed_unavailable_size');
   window.location.replace(target.toString());
   return;
  }
  let rows; try { rows = JSON.parse(this.querySelector('[data-stock-variants]').textContent); } catch { this.hidden = true; return; }
  this.rows = new Map(rows.map(row => [String(row.id), row]));
  this.eventName = `variant:change:${this.dataset.sectionId}:${this.dataset.productId}`;
  this.listener = event => { const { variant, loading } = event.detail || {}; if (loading) { this.hidden = true; return; } if (this.sizeNotice) this.sizeNotice.hidden = true; const url = new URL(window.location.href); if (url.searchParams.has('bed_unavailable_size')) { url.searchParams.delete('bed_unavailable_size'); window.history.replaceState({}, '', url); } this.update(variant?.id); };
  document.addEventListener(this.eventName, this.listener);
  const picker = document.querySelector(`kit-variant-picker[data-product-id="${this.dataset.productId}"]`);
  let initial; try { initial = JSON.parse(picker?.querySelector('[data-kit-selected-variant]')?.textContent || 'null'); } catch {}
  this.update(initial?.id || document.querySelector(`block-buy-buttons[data-product-id="${this.dataset.productId}"] input[name="id"]`)?.value);
 }
 update(id) {
  const row = this.rows.get(String(id)); this.hidden = !row || row.available;
  if (this.hidden) return;
  let count = 0; this.querySelectorAll('[data-alternative-size]').forEach(link => { link.hidden = link.dataset.alternativeSize !== row.size; if (!link.hidden) count++; });
  this.querySelector('[data-no-alternatives]').hidden = count > 0;
  this.querySelector('[data-alternative-heading]').hidden = count === 0;
 }
 disconnectedCallback() { document.removeEventListener(this.eventName, this.listener); this.listener = null; }
});
